import React from "react";
import { NavLink, useNavigate } from "react-router-dom";
import {
  LayoutDashboard, TicketCheck, Users, Building2, CalendarClock, Clock,
  MessagesSquare, BarChart3, History, LogOut, LayoutGrid,
} from "lucide-react";
import { LOGO_URL } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";

const items = [
  { to: "/ticket", label: "Dashboard", icon: LayoutDashboard, testid: "tnav-dashboard", end: true },
  { to: "/ticket/tickets", label: "GWV Tickets", icon: TicketCheck, testid: "tnav-tickets" },
  { to: "/ticket/kunden", label: "Kundenkontakt", icon: MessagesSquare, testid: "tnav-kunden" },
  { to: "/ticket/termine", label: "Terminierung", icon: CalendarClock, testid: "tnav-termine" },
  { to: "/ticket/partner", label: "Partnerfirmen", icon: Building2, testid: "tnav-partner" },
  { to: "/ticket/kapazitaeten", label: "Kapazitäten", icon: BarChart3, testid: "tnav-kap" },
  { to: "/ticket/abwesenheiten", label: "Abwesenheiten", icon: Clock, testid: "tnav-abwesend" },
  { to: "/ticket/mitarbeiter", label: "Techniker", icon: Users, testid: "tnav-mitarbeiter" },
  { to: "/ticket/berichte", label: "Berichte", icon: BarChart3, testid: "tnav-berichte" },
  { to: "/ticket/audit", label: "Audit Log", icon: History, testid: "tnav-audit" },
];

export default function TicketSidebar() {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  return (
    <aside
      data-testid="ticket-sidebar"
      className="skalar-grid w-64 h-screen sticky top-0 flex flex-col text-white"
      style={{ background: "#0A2540" }}
    >
      <div className="px-6 py-4 border-b border-white/10">
        <button
          onClick={() => nav("/modules")}
          data-testid="ticket-to-modules"
          className="w-full flex items-center gap-2 px-3 py-2 rounded-md text-sm font-semibold bg-white/10 hover:bg-white/15 transition-colors"
        >
          <LayoutGrid className="h-4 w-4" /> Zur Modulauswahl
        </button>
      </div>
      <div className="px-6 py-4 border-b border-white/10">
        <div className="flex items-center gap-2.5">
          <div className="w-10 h-10 rounded-md flex items-center justify-center bg-white p-1">
            <img src={LOGO_URL} alt="ST" className="w-full h-full object-contain" />
          </div>
          <div className="leading-tight">
            <div className="text-base font-bold tracking-wide">Ticket Disposition</div>
            <div className="text-[11px] uppercase opacity-60 tracking-widest">GWV · FTTH</div>
          </div>
        </div>
      </div>
      <nav className="flex-1 overflow-y-auto p-3 space-y-0.5">
        {items.map((i) => (
          <NavLink
            key={i.to}
            to={i.to}
            end={i.end}
            className={({ isActive }) => `nav-item ${isActive ? "active" : ""}`}
            data-testid={i.testid}
          >
            <i.icon className="h-4 w-4" strokeWidth={2} />
            <span>{i.label}</span>
          </NavLink>
        ))}
      </nav>
      <div className="p-3 border-t border-white/10">
        <div className="flex items-center justify-between px-2 py-2">
          <div className="leading-tight">
            <div className="text-sm font-semibold truncate max-w-[140px]">{user?.name}</div>
            <div className="text-[11px] opacity-60 uppercase tracking-wider">{user?.role}</div>
          </div>
          <button
            onClick={async () => { await logout(); nav("/login"); }}
            className="p-2 rounded-md hover:bg-white/10"
            aria-label="Abmelden"
            data-testid="ticket-logout"
          >
            <LogOut className="h-4 w-4" />
          </button>
        </div>
      </div>
    </aside>
  );
}
